module.exports = __webpack_public_path__ + "assets/img/1381587607330_.pic_hd.3d887fb5.jpg";